import * as url from "helpers/url_helper/url_helper"
import { get } from "helpers/api_helper/ApiHelpers/apiHelpers"

export const getTransactionInstallmentTypeDefList = () => get(url.TRANSACTION_INSTALLMENT_TYPE_DEF_GET)